import { render, staticRenderFns } from "./ModalParcelamentos.vue?vue&type=template&id=707e4d55"
import script from "./ModalParcelamentos.vue?vue&type=script&lang=js"
export * from "./ModalParcelamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports